import { HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import AuthorizationError from './authorization-error';
import InternalServerError from './internal-server-error';
import NetworkError from './network-error';
import ParseError from './parse-error';
import UnknownError from './unknown-error';
import UnSupportedMediaTypeError from './unsupported-media-type-error';

/** Converts HttpErrorResponse status codes to domain specific error instances. */
export function handleDomainError(error: HttpErrorResponse | ParseError): Observable<NetworkError | AuthorizationError | InternalServerError | ParseError | UnknownError | UnSupportedMediaTypeError> {
	if (error instanceof ParseError) {
		return of(error);
	}
	if (error.status === 0) {
		return of(new NetworkError());
	}
	if (error.status === 401) {
		return of(new AuthorizationError());
	}
	if (error.status === 415) {
		return of(new UnSupportedMediaTypeError());
	}
	if (error.status === 500 || error.status === 502) {
		return of(new InternalServerError());
	}
	return of(new UnknownError());
}
